import { create } from '@thoughtspot/logger';
import Joi from 'joi';
const logger = create('ts-to-chart > event-callbacks > update-chart-config');
const getUpdateChartConfigEventProcessor = (props) => {
    const { updateChartConfig } = props;
    return {
        validateEventPayload: (eventData) => {
            try {
                const UpdateChartConfigEventPayloadSchema = Joi.object({
                    chartConfig: Joi.array().min(1).required(),
                    skipRerender: Joi.boolean().optional(),
                    isUserAction: Joi.boolean().optional(),
                }).unknown(false);
                if (!eventData || !eventData.payload) {
                    throw new Error('Event payload is required');
                }
                Joi.assert(eventData.payload, UpdateChartConfigEventPayloadSchema);
            }
            catch (err) {
                logger.warn(err);
                return {
                    isValid: false,
                    errors: [err.toString()],
                };
            }
            return {
                isValid: true,
            };
        },
        executeEvent: async (eventData) => {
            const { chartConfig, skipRerender, isUserAction } = eventData.payload;
            return updateChartConfig(chartConfig, skipRerender, isUserAction);
        },
    };
};
const testHooks = {
    getUpdateChartConfigEventProcessor,
};
export { testHooks, getUpdateChartConfigEventProcessor };
//# sourceMappingURL=index.js.map